import styled from 'styled-components'
import { useWeb3React } from '@web3-react/core'
import { ArrowBackIcon, ArrowForwardIcon, IconButton, Flex } from 'uikit'
import useLocalDispatch from 'contexts/LocalRedux/useLocalDispatch'
import { PredictionStatus } from 'state/types'
import { useGetPredictionsStatus, useIsChartPaneOpen, useIsHistoryPaneOpen } from 'state/predictions/hooks'
import { setChartPaneState, setHistoryPaneState } from 'state/predictions'
import useSwiper from '../hooks/useSwiper'

const ButtonNav = styled.div`
  flex: none;
`

const TabNav = styled.div`
  flex: 1;
  text-align: center;
  display: flex;
  justify-content: center;
`

const StyledMobileMenu = styled.div`
  align-items: center;
  background-color: ${({ theme }) => theme.card.background};
  height: 64px;
  position: fixed;
  width: 100%;
  bottom: 0;
  z-index: 1;
  display: flex;
  ${({ theme }) => theme.mediaQueries.lg} {
    display: none;
  }
`

const StyledContainer = styled(Flex)<{ active: boolean; mr?: string }>`
  width: 40px;
  height: 40px;
  border-radius: 20px;
  background: ${({ active }) => (active ? '#14D89D' : 'white')};
  justify-content: center;
  align-items: center;
  margin-right: ${({ mr }) => mr ?? '0px'};
`

const StyledImgIcon = styled.img`
  width: 24px;
  height: 24px;
`

const Imgs = {
  chart: require('assets/images/prediction/menu-char.svg').default,
  'chart-l': require('assets/images/prediction/menu-char-l.svg').default,
  main: require('assets/images/prediction/menu-main.svg').default,
  'main-l': require('assets/images/prediction/menu-main-l.svg').default,
  history: require('assets/images/prediction/menu-history.svg').default,
  'history-l': require('assets/images/prediction/menu-history-l.svg').default,
}

const getActiveIndex = (isHistoryOpen: boolean, isChartOpen: boolean) => {
  if (isHistoryOpen) {
    return 2
  }

  if (isChartOpen) {
    return 1
  }

  return 0
}

const MobileMenu = () => {
  const { swiper } = useSwiper()
  const isHistoryOpen = useIsHistoryPaneOpen()
  const isChartOpen = useIsChartPaneOpen()
  const status = useGetPredictionsStatus()
  const activeIndex = getActiveIndex(isHistoryOpen, isChartOpen)
  const dispatch = useLocalDispatch()
  const { account } = useWeb3React()

  const handleItemClick = (index: number) => {
    switch (index) {
      case 2:
        dispatch(setHistoryPaneState(true))
        break
      case 1:
        dispatch(setChartPaneState(true))
        dispatch(setHistoryPaneState(false))
        break
      case 0:
      default:
        dispatch(setHistoryPaneState(false))
        dispatch(setChartPaneState(false))
    }
  }

  return (
    <StyledMobileMenu>
      <ButtonNav>
        <IconButton variant="text" onClick={() => swiper.slidePrev()} disabled={status !== PredictionStatus.LIVE}>
          <ArrowBackIcon width="24px" color="primary" />
        </IconButton>
      </ButtonNav>
      <TabNav>
        <StyledContainer active={activeIndex === 0} mr="30px" onClick={() => handleItemClick(0)}>
          <StyledImgIcon src={Imgs[activeIndex === 0 ? 'main-l' : 'main']} />
        </StyledContainer>
        <StyledContainer active={activeIndex === 1} mr="30px" onClick={() => handleItemClick(1)}>
          <StyledImgIcon src={Imgs[activeIndex === 1 ? 'chart-l' : 'chart']} />
        </StyledContainer>
        {!account ? null : (
          <StyledContainer
            active={activeIndex === 2}
            onClick={() => {
              if (!account) return
              handleItemClick(2)
            }}
          >
            <StyledImgIcon src={Imgs[activeIndex === 2 ? 'history-l' : 'history']} />
          </StyledContainer>
        )}

        {/* <ButtonMenu activeIndex={activeIndex} scale="sm" variant="subtle" onItemClick={handleItemClick}>
          <ButtonMenuItem>
          <ButtonMenuItem>{/* <ChartIcon color="currentColor" /> </ButtonMenuItem>
            {/* <Cards color="currentColor" />
          </ButtonMenuItem> 
          <ButtonMenuItem disabled={!account}>
            <HistoryIcon color="currentColor" />
          </ButtonMenuItem>
        </ButtonMenu>  */}
      </TabNav>
      <ButtonNav>
        <IconButton variant="text" onClick={() => swiper.slideNext()} disabled={status !== PredictionStatus.LIVE}>
          <ArrowForwardIcon width="24px" color="primary" />
        </IconButton>
      </ButtonNav>
    </StyledMobileMenu>
  )
}

export default MobileMenu
